// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0f049ef0","239":"d33467ea","455":"9bbca98c"}[chunkId] + ".chunk.js";
};